import { Collapse } from "antd";
import React from "react";

const { Panel } = Collapse;

const expandIcon = ({ isActive }) => {
  return isActive ? (
    <div className="size-3 xl:size-4 xl:mt-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 12 2.313"
      >
        <path
          id="Path_76"
          data-name="Path 76"
          d="M8.027,21.1h4.789V18.788h-12V21.1H8.027Z"
          transform="translate(-0.816 -18.789)"
          fill="#dc6b25"
        />
      </svg>
    </div>
  ) : (
    <div className="size-3 xl:size-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 12 12.484"
      >
        <path
          id="Path_76"
          data-name="Path 76"
          d="M5.632,24H8.027V18.911h4.789V16.6H8.027V11.512H5.632V16.6H.816v2.314H5.632Z"
          transform="translate(-0.816 -11.512)"
          fill="#dc6b25"
        />
      </svg>
    </div>
  );
};

const HcAccordion = ({ headline, accordion }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-accordion wp-block-kehittamo-block-hc">
      <div className="flex flex-col xl:flex-row">
        <h2 className="mt-4 text-lg font-bold xl:w-1/3 xl:text-2xl">
          {headline}
        </h2>
        <Collapse ghost expandIconPosition="end" expandIcon={expandIcon}>
          {accordion.map((item, index) => (
            <Panel header={item.headline} key={index + 1}>
              <div
                className="accordion-content"
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            </Panel>
          ))}
        </Collapse>
      </div>
    </div>
  );
};

export default HcAccordion;
